import { useLazyQuery, useQuery } from "@apollo/client/react"; import { Autocomplete, Box, TextField, Grid, InputAdornment, CircularProgress } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { useDebounce } from '../../../../hooks/useDebounce';
import { GET_INSUMOS } from '../../../../data/graphQL/queries/ResumenIngreso/getAllInsumos';
import SearchIcon from '@mui/icons-material/Search';
import { adaptInsumosArray } from '../../../../adapters/resumenIngreso/insumosAdapter';
import toast from 'react-hot-toast';

export const StepProgramaAP2 = ({
  setDataSubmissionCallback,
  pantallas,
  updateFormData,
  fullFormDataRI,
  idDatosGeneralesRI,
  edit
}) => {
  const [datosProgramaAP, setDatosProgramaAP] = useState(fullFormDataRI?.programaAP2 ?? {});
  const [combosRI, setCombosRI] = useState();

  const [
    insumos,
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected] =
    useGetInsumos(datosProgramaAP?.idInsumo, fullFormDataRI?.programaAP2?.nombreInsumo, idDatosGeneralesRI);


  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  useEffect(() => {
    setDatosProgramaAP((prevData) => ({
      ...prevData,
      idPantallaRI: pantallas.find((p) => p.displayName.includes('AP'))?.id
    }));
  }, [pantallas]);

  const handleSubmit = () => {
    if (!datosProgramaAP?.bAPestandar && !datosProgramaAP?.magistral) {
      return toast.error('Debe indicar BAP Estándar o BAP Magistral');
    }
    updateFormData('programaAP2', datosProgramaAP, parsedInputsGroup.flatMap((x) => x.inputs));
  };

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const handleChange = (name, value) => {
    setDatosProgramaAP((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const parsedInputsGroup = useMemo(() => {

    if (!combosRI) return inputsGroups;

    return inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName) {
          input.options = combosRI[input.name];
        }
        const colocacionId = combosRI?.idComboRIValorTipoCateter?.find((c) => c.displayName.includes('En espera de colocación'))?.id;
        switch (input.name) {
          case 'justificarTipoCateter':
            const transitorioId = combosRI.idComboRIValorTipoCateter.find((c) => c.displayName.includes('Transitorio')).id;
            input.required = !!(datosProgramaAP.idComboRIValorTipoCateter === transitorioId) || !!(datosProgramaAP.idComboRIValorTipoCateter === colocacionId);
            input.disabled = !(datosProgramaAP.idComboRIValorTipoCateter === transitorioId) && !(datosProgramaAP.idComboRIValorTipoCateter === colocacionId);
            if (input.disabled) handleChange(input.name);
            break;
          case 'fechaColocacionCateter':
          case 'idComboRIValorUbicacionCateter':
          case 'idComboRIValorNroLumenes':
            input.required = !(datosProgramaAP.idComboRIValorTipoCateter === colocacionId);
            break;
          case 'volumenMagistral':
            input.required = !!datosProgramaAP.magistral;
            input.disabled = !datosProgramaAP.magistral;
            if (input.disabled) handleChange(input.name);
            break;
          case 'diasConexionSemanaMagistral':
            input.required = !!datosProgramaAP.magistral;
            input.options = input.options.map((o) => ({ ...o, disabled: datosProgramaAP.diasConexionSemana?.includes(o.value) }));
            input.disabled = !datosProgramaAP.magistral;
            if (input.disabled) handleChange(input.name);
            break;
          case 'idInsumo':
            input.required = !!datosProgramaAP.bAPestandar;
            input.disabled = !datosProgramaAP.bAPestandar;
            if (input.disabled) {
              handleChange(input.name);
              setFilterStatus('');
            }
            break;
          case 'cantidadDiaria':
            input.required = !!datosProgramaAP.bAPestandar;
            input.disabled = !datosProgramaAP.bAPestandar;
            if (input.disabled) handleChange(input.name);
            break;
          case 'idComboRIValorMotivoIndicacionEstandar':
            input.required = !!datosProgramaAP.bAPestandar;
            input.options = input.options.filter((o) => o.displayName.includes('Mixto'));
            input.disabled = !datosProgramaAP.bAPestandar;
            if (input.disabled) handleChange(input.name);
            break;
          case 'diasConexionSemana':
            input.required = !!datosProgramaAP.bAPestandar;
            input.options = input.options.map((o) => ({ ...o, disabled: datosProgramaAP.diasConexionSemanaMagistral?.includes(o.value) }));
            input.disabled = !datosProgramaAP.bAPestandar;
            if (input.disabled) handleChange(input.name);
            break;
          case 'bAPxAdelantado':
            input.hidden = !datosProgramaAP.magistral;
            input.required = !input.hidden;
            if (input.hidden) handleChange(input.name, false);
            break;
          default:
            break;
        }
        return input;
      })
    }));
  }, [
    combosRI,
    datosProgramaAP.idComboRIValorTipoCateter,
    datosProgramaAP.magistral,
    datosProgramaAP.bAPestandar,
    datosProgramaAP.idInsumo,
    datosProgramaAP.diasConexionSemanaMagistral,
    datosProgramaAP.diasConexionSemana]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaAP, setDataSubmissionCallback, parsedInputsGroup]);

  const handleSelectInsumo = (newValue) => {
    handleChange('idInsumo', newValue.id);
    setNombreInsumoSelected(newValue.label);
  };

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className={`step-form-section-title`}>
            {group.groupName}
          </label>
          <Grid container>
            {group.inputs.filter((x) => !x.hidden).map((input) => {
              return (
                <>
                  {input.name !== 'idInsumo' && <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={handleChange}
                    input={input}
                    value={datosProgramaAP[input.name]} />
                  }
                  {input.name === 'idInsumo' && <Grid sx={{ marginTop: 2.5 }} size={{ xs: 12 }}>
                    <Autocomplete
                      options={insumos}
                      disabled={input.disabled}
                      key={datosProgramaAP?.idInsumo}
                      value={nombreInsumoSelected}
                      disableClearable
                      noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
                      onChange={(_, newValue) => handleSelectInsumo(newValue)}
                      renderOption={(props, option) => {
                        return (
                          <Box {...props} key={option.id}>
                            {option?.label}
                          </Box>);

                      }}
                      renderInput={(params) => <TextField
                        {...params}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
                        label={`${input.displayName}${input.required ? '*' : ''}`}
                        margin='none'
                        size='small'
                        inputProps={{
                          ...params.inputProps,
                          value: !!datosProgramaAP.idInsumo || !!filterStatus ? params.inputProps.value : ''
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment:
                            <InputAdornment position='end'>
                              {insumosLoading ?
                                <CircularProgress color='inherit' size={20} /> :
                                <SearchIcon className='search-icon' />}
                            </InputAdornment>

                        }} />

                      } />

                  </Grid>}
                </>);

            })}
          </Grid>
        </div>
      )}
    </div>);

};

const useGetInsumos = (idInsumo, nombreInsumo, idDatosGeneralesRI) => {

  const [insumos, setInsumos] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const [nombreInsumoSelected, setNombreInsumoSelected] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInsumos, { loading: insumosLoading, data: insumosResults }] = useLazyQuery(GET_INSUMOS);

  useEffect(() => {
    if (!insumosResults) return;

    setInsumos(insumosResults);
  }, [insumosResults]);

  useEffect(() => {
    if (!nombreInsumo) return;
    setFilterStatus(nombreInsumo);
    setNombreInsumoSelected(nombreInsumo);
  }, [nombreInsumo]);

  useEffect(() => {
    if (!insumosLoading && !!debouncedFilterValue?.trim()) {
      getInsumos({
        variables: {
          idDatosGenerales: idDatosGeneralesRI,
          where: { descripcion: { contains: debouncedFilterValue } }
        }
      });
    }
  }, [debouncedFilterValue]);

  return [
    adaptInsumosArray(insumos) || [],
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected];


};

const inputsGroups = [
  {
    groupName: 'Accesos Parenteral',
    inputs: [
      {
        displayName: 'Tipo de Catéter',
        name: 'idComboRIValorTipoCateter',
        comboName: 'Tipo de Catéter AP',
        type: 'select',
        required: true,
        disabled: false
      },
      {
        displayName: 'Justificar si es Transitorio/ En espera de colocación',
        name: 'justificarTipoCateter',
        type: 'string',
        maxLength: 2000,
        required: false
      },
      {
        displayName: 'Fecha de colocación',
        name: 'fechaColocacionCateter',
        type: 'date',
        disableFuture: true,
        required: true
      },
      {
        displayName: 'Ubicación de catéter',
        name: 'idComboRIValorUbicacionCateter',
        comboName: 'Ubicación del catéter AP',
        type: 'select',
        required: true
      },
      {
        displayName: 'N° de lúmenes',
        name: 'idComboRIValorNroLumenes',
        comboName: 'N° de Luces',
        type: 'select',
        required: true
      },
      {
        displayName: '¿Sitio de inserción del catéter normal?',
        name: 'insercionCateterNormal',
        type: 'boolean',
        required: true
      }]

  },
  {
    groupName: 'Indicaciones',
    inputs: [
      {
        displayName: 'BAP Magistral',
        name: 'magistral',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Volumen',
        name: 'volumenMagistral',
        type: 'float',
        min: 0,
        max: 4000,
        required: false
      },
      {
        displayName: 'Conexiones por semana',
        name: 'diasConexionSemanaMagistral',
        type: 'checkbox',
        options: [
          { value: 1, label: 'L' },
          { value: 2, label: 'M' },
          { value: 3, label: 'X' },
          { value: 4, label: 'J' },
          { value: 5, label: 'V' },
          { value: 6, label: 'S' },
          { value: 7, label: 'D' }],

        selectAllOption: true,
        required: false
      },
      {
        displayName: 'BAP Estándar',
        name: 'bAPestandar',
        type: 'boolean',
        required: true
      },
      {
        displayName: '¿Cuál?',
        name: 'idInsumo',
        type: 'search',
        required: true
      },
      {
        displayName: 'Cantidad diaria',
        name: 'cantidadDiaria',
        type: 'int',
        min: 0,
        max: 2,
        required: false
      },
      {
        displayName: 'Motivo de la indicación Estándar',
        name: 'idComboRIValorMotivoIndicacionEstandar',
        comboName: 'Motivo de la indicación Estandar AP',
        type: 'select',
        required: false
      },
      {
        displayName: 'Conexiones por semana',
        name: 'diasConexionSemana',
        type: 'checkbox',
        options: [
          { value: 1, label: 'L' },
          { value: 2, label: 'M' },
          { value: 3, label: 'X' },
          { value: 4, label: 'J' },
          { value: 5, label: 'V' },
          { value: 6, label: 'S' },
          { value: 7, label: 'D' }],

        selectAllOption: true,
        required: true
      },
      {
        displayName: '¿Requiere BAP magistral adelantada?',
        name: 'bAPxAdelantado',
        type: 'boolean',
        required: false
      },
      {
        displayName: 'Modo de infusión',
        name: 'idComboRIValorModoInfusion',
        comboName: 'Modo de infusión AP',
        type: 'select',
        required: true
      },
      {
        displayName: 'Sellado de catéter',
        name: 'idComboRIValorSelladoCateter',
        comboName: 'Sellado de catéter AP',
        type: 'select',
        required: true
      }]

  }];